module.exports = __webpack_public_path__ + "static/averta-bold-001b18896ca4c8eb8cde29212a0ad6b7.woff";